import { type Signal } from '@angular/core';

/** An entity name, paired with the id it was resolved for. */
export interface ChatContextName {
  id: string | number;
  name: string;
}

/**
 * Per-app source of entity names for the ids the route puts in the chat context.
 * Apps that provide none display the raw ids.
 */
export abstract class AbstractChatContextNamesService {
  /** Names keyed by context id key (`portfolioId`, `propertyId`, …). */
  public abstract readonly names: Signal<
    Readonly<Record<string, ChatContextName | undefined>>
  >;
}
